$( document ).ready(function() {
console.log("a11y start");

$(".accessibility-statement h4").attr({
    role: 'heading',
    "aria-level": "2"
});

$("nav.category-navigation").attr("aria-label", "main");

$(".a11y_h3inpart").each(function () {
    const $this = $(this);
    const text = $this.text().trim();
    $this.attr("aria-hidden", "true");
    $this.after(
        $("<h2>", {
            class: "sr-only",
            text: text
        })
    );
});

$(".custom_radio_field").each(function(){
    $(this).find("p.field__labels").attr("id", "enquiry_id");
    $(this).find('input#ContactForm-no').attr("aria-labelledby", "enquiry_id ContactForm-no");
    $(this).find('input#ContactForm-yes').attr("aria-labelledby", "enquiry_id ContactForm-yes");
});

$('.section-stack__intro a[href*="/hc/en-us"]').attr("aria-label", "FAQ section").removeAttr("title");

$("#shopify-section-template--20020837482675__contact p.subheading").attr({
    role: 'heading',
    "aria-level": "1"
});

$("<div>", {
    id: "sr-announcer",
    "aria-live": "polite",
    "aria-atomic": "true",
    role: "alert",
    style:
      "position:absolute; left:-9999px; height:1px; width:1px; overflow:hidden;",
  }).appendTo("body");
  function announce(message) {
    const $announcer = $("#sr-announcer");
    $announcer.text("");
    setTimeout(() => {
      $announcer.text(message);
    }, 50);
  }
  function bindAnnounce(selector, message) {
    $(selector).on("click keydown", function (e) {
      if (
        e.type === "click" ||
        (e.type === "keydown" &&
          (e.key === "Enter" || e.key === " " || e.key === "Spacebar"))
      ) {
        announce(message);
        console.log("Button hit");
      }
    });
}

bindAnnounce("buy-buttons button.button", "Loading");
bindAnnounce('button[data-skio-name="login-email-submit-button"]', "Loading");
bindAnnounce(".product-info__customer-reviews button.circle-button, button.prev-button,button.next-button,.swiper--nav.review-swiper--prev,.swiper--nav.review-swiper--next", "Slide Changed");
bindAnnounce("button.prev-button,button.next-button,.swiper--nav.review-swiper--prev,.swiper--nav.review-swiper--next,.pwwp__button--arrow--left,.pwwp__button--arrow--right,button.is-prev,button.is-next", "Slide Changed");
bindAnnounce('form[data-testid^="klaviyo-form"] button', "Loading");
bindAnnounce('form.main-search-form button.button,.product-card .pointer-coarse button.button', "Loading");

$("h3#sign-up").attr({
    role: 'heading',
    "aria-level": "2"
});

// $('label[for="request_anonymous_requester_email"]').text("Your email address *");
// $('label#request_subject_label').text("Subject *");
// $('label#request_description_label').text("Description *");
// $('form#new_request').each(function () {
//     $(this).prepend('<div class="required_message">Fields marked with * are required.</div>');
// });

$("line-item.line-item").each(function(){
    const $text = $(this).find(".line-item__info a.product_title").text().trim();
    const $deletebtn = $(this).find(".text-xs a.link");
    const $infield = $(this).find(".quantity-input");
    $deletebtn.attr("aria-label", "Remove " + $text);
    $infield.attr("aria-label", "Edit " + $text);
});

setInterval(function(){
    $(".shipping-estimator__results .v-stack").attr("role", "alert")

    $("#header-sidebar-menu").removeAttr("role").removeAttr("aria-modal");
    $("#cart-drawer").removeAttr("role").removeAttr("aria-modal");
    $("quick-buy-drawer").removeAttr("role").removeAttr("aria-modal");

    $("#contact-form-template--20020837482675__contact button.button").removeAttr("aria-busy");
}, 1000);

$("aside#shopify-section-sections--20020830208179__announcement-bar").attr("role", "none");

$('img[src*="freshcap.svg"], .footer-logo a img').attr("alt", "FreshCap logo");

$('marquee-text img[src*="Rectangle_99_3.svg"]').attr("alt", "Vice logo");
$('marquee-text img[src*="Rectangle_98.svg"]').attr("alt", "Medium logo");
$('marquee-text img[src*="Rectangle_97.svg"]').attr("alt", "Bazaar logo");
$('marquee-text img[src*="Rectangle_96.svg"]').attr("alt", "Goop logo");
$('marquee-text img[src*="Rectangle_95_1.svg"]').attr("alt", "Forbes logo");
$('marquee-text img[src*="Rectangle_94.svg"]').attr("alt", "Vogue logo");


$(".video_testimonial__info p.h5, .testimonial__info p.h5, .collection-card__content p.h5").attr({
    role: "heading",
    "aria-level": "3"
});

$(".product-info__complementary-products h4.h4").attr({
    role: "heading",
    "aria-level": "2"
});
$(".image-with-text__content .image-with-text__key-points-wrapper  h4.h4").attr({
    role: "heading",
    "aria-level": "3"
});

$(".accordion-top-title h1.h1").attr({
    role: "heading",
    "aria-level": "2"
});

$("div.product").each(function(){
    const $producttext = $(this).find("safe-sticky .product_info_title h1.product-info__title").text().trim();
    const $img = $(this).find("product-gallery .rio-hide-scrollbar.PwzrGrid-container > div img");
    const $main_img = $(this).find("#pwzrswiper-wrapper .pwzrswiper-slide img");
    $img.each(function(index){
        $(this).attr("alt", "Image " + (index + 1) + " of product " + $producttext);
    });
    $main_img.each(function(index){
        $(this).attr("alt", "Main image " + (index + 1) + " of product " + $producttext);
    });
});

$("safe-sticky.product-info").each(function(){
    const $text = $(this).find("h1.product-info__title").text().trim();
    const $video = $(this).find(".video-reels-lists .video-reel-item");
    $video.each(function(index){
        const $anch = $(this).find("a");
        $anch.attr("aria-label", "Video " + (index + 1) + " of " + $text);
    });
});

$("button.back-to-top").attr("aria-label", "Back to top");
$('.main-search-form .search-input button[type="submit"]').attr("aria-label", "Search");

$('#shopify-section-template--20020837646515__main .prose iframe').attr("aria-label", "Iframe video");

$('meta[content="width=device-width, initial-scale=1.0, height=device-height, minimum-scale=1.0, maximum-scale=1.0"]').attr("content","width=device-width, initial-scale=1.0, height=device-height, minimum-scale=1.0, maximum-scale=2");

$('scroll-carousel#scroll-area-template--20020837286067__video_reels_testimonials_E3YbLa .video_testimonial').each(function(){
    const $text = $(this).find("p.h5").text().trim();
    const $videoanchr = $(this).find(".video_reel_wrapper .video-reels-product__image a");
    const $image = $(this).find(".video_reel_wrapper .video-reels-product__image a img");
    $image.attr("alt", "Image of " + $text);
    $videoanchr.attr("aria-label", $text);
});

$(".empty-state p.h4").attr({
    role: "heading",
    "aria-level": "1"
});

$("details.accordion").each(function(){
    const $text = $(this).find(".accordion__toggle span").text().trim();
    const $region = $(this).find(".accordion__content");
    $region.attr({
        role: "group",
        "aria-label": $text
    });
});

// $("price-list").each(function(){
//     const $discounted = $(this).find("sale-price");
//     $discounted.append('<span class="sr-only"> Discounted price </span>');
// });

$(".mega-menu .mega-menu__nav .v-stack > a > span").attr({
    role: "heading",
    "aria-level": "2"
});

$("image-banner p.heading.h2").attr({
    role: "heading",
    "aria-level": "2"
});

$('#shopify-section-template--20020837286067__collection_list_EmQYNG').attr({
    role: "region",
    "aria-label": "Pick your perfect mush"
});
$('#shopify-section-template--20020837286067__video_reels_testimonials_E3YbLa').attr({
    role: "region",
    "aria-label": "Why people choose FreshCap"
});
$('#shopify-section-template--20020837286067__testimonials_jaTtRi').attr({
    role: "region",
    "aria-label": "The word on the mush"
});

$("progress-bar.progress-bar").attr({
    role: "progressbar",
    "aria-label": "progress bar"
});

$('.header__icon-list a[href="/cart"]').attr("aria-label", "Cart");
$('.header__icon-list a[href="/search"]').attr("aria-label", "Search");

setInterval(() => {

$(".yotpo-smart-topics-container").attr({
    role: "group",
    "aria-label": "Popular topics"
});


// $(".yotpo-widget-clear button").attr("tabindex", "-1");

$("#pwzrswiper-wrapper .pwzrswiper-slide-active").attr("tabindex", "0");
$('#pwzrswiper-wrapper .pwzrswiper-slide-active').attr('role', 'button');
$('#pwzrswiper-wrapper .pwzrswiper-slide-active').on('keydown', function(e) {
if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
	e.preventDefault();
	$(this).click();
}
});
$(".pwwp__top-bar .pwwp__button--close").attr("aria-label", "Close").removeAttr("title");
$(".pwwp__top-bar .pwwp__button--share").attr("aria-label", "Share").removeAttr("title");
$(".pwwp__top-bar .pwwp__button--fs").attr("aria-label", "Toggle fullscreen").removeAttr("title");
$(".pwwp__top-bar .pwwp__button--zoom").attr("aria-label", "Zoom in/out").removeAttr("title");
$(".pwwp__button--arrow--right").attr("aria-label", "Next").removeAttr("title");
$(".pwwp__button--arrow--left").attr("aria-label", "Previous").removeAttr("title");

$("dialog.fancybox__dialog").attr("role", "dialog");

$('div[role="region"][aria-label="Notifications (F8)"]').removeAttr("role").removeAttr("aria-label");

bindAnnounce("quick-buy-drawer buy-buttons button.button", "Item added to cart");
bindAnnounce("form.main-search-form button.button", "Loading");
bindAnnounce("quantity-selector .quantity-selector__button", "Quantity changed");
bindAnnounce("button.f-button", "slide changed");
bindAnnounce("product-card button.button", "Loading");
bindAnnounce("#contact-form-template--20020837482675__contact button.button", "Loading");
}, 1000);
$(".product-info__discount-offer .swiper--prev").attr("aria-label", "previous offer slide");
$(".product-info__discount-offer .swiper--next").attr("aria-label", "next offer slide");
$(".product-info__customer-reviews .review-swiper--prev").attr("aria-label", "previous review slide");
$(".product-info__customer-reviews .review-swiper--next").attr("aria-label", "next review slide");
 
function toggleDecreaseBtn($selector) {
    const $input = $selector.find(".quantity-selector__input");
    const $decreaseBtn = $selector.find('.quantity-selector__button[aria-label="Decrease quantity"]');
    const value = parseInt($input.val(), 10);
    if (value <= 1) {
      $decreaseBtn.attr("disabled", true).attr("aria-disabled", "true");
    } else {
      $decreaseBtn.removeAttr("disabled").removeAttr("aria-disabled");
    }
}
$(".quantity-selector").each(function () {
    toggleDecreaseBtn($(this));
});
$(document).on("input change", ".quantity-selector__input", function () {
    toggleDecreaseBtn($(this).closest(".quantity-selector"));
});
$(document).on("click", ".quantity-selector__button", function () {
    const $selector = $(this).closest(".quantity-selector");
    setTimeout(function () {
      toggleDecreaseBtn($selector);
    }, 0);
});

const logoScrollSection = '#shopify-section-template--20020837286067__logo_list_original_nBNGYD';
$(logoScrollSection + ' .scrolling-text__text')
  .attr('aria-hidden','true')
  .first().attr('aria-hidden','false');
$(logoScrollSection + ' .scrolling-text__text')
  .attr('role','list');
$(logoScrollSection + ' .scrolling-text__text span')
  .attr('role','listitem');

$(document).on("change", ".checkbox-list input[type='checkbox']", function () {
  setTimeout(function () {
    $(".product-list a").first().focus();
}, 1000);});

$(document).on('focusin', 'details[is="mega-menu-disclosure"] summary, .mega-menu a', function () {
    var $details = $(this).closest('details');
    $details.prop('open', true);
    $details.find('.mega-menu').css('opacity', '1');
});
$(document).on('keydown', function (e) {
    if (e.key === "Escape") {
      $('details[is="mega-menu-disclosure"][open]').each(function () {
        $(this).find('.mega-menu').css('opacity', '0');
        $(this).prop('open', false);
        $(this).find('summary').focus();
      });
    }
});

$(document).ready(function () {
  if (window.location.pathname.includes("/cart")) {
    $("title").text(function (i, currentTitle) {
      return currentTitle + " | FreshCap";
    });
  }
});

$("product-list.product-list product-card").each(function(){
    const $img = $(this).find(".product-card__figure a img.product-card__image--secondary");
    $img.attr("alt", "");
});

$("product-recommendations h4").attr({
    role: "heading",
    "aria-level": "2"
});

$("span.count-bubble.count-bubble--lg").attr("aria-hidden", "true");

setTimeout(function(){
$("scroll-carousel product-list product-card .product-card__image--secondary").each(function(){
    $(this).attr("alt", "");
});

$("nav.navigation-container").attr("aria-label", "Mainmenu");

}, 800);

$("scroll-carousel.testimonial-list .video_testimonial").each(function(){
    const $btn = $(this).find(".play__btn.play_video");
    const $text = $(this).find(".video_testimonial__info .pi-testimonial-card__link").text().trim();
    $btn.attr("aria-label", "Play video that is demonstrating how to " + $text);
    const $img = $(this).find("video.reel_video img");
    $img.attr("alt", "")
});


// $('<button class="marquee-toggle" aria-pressed="false" style="background-color: black; color: white; padding: 5px;">Pause</button>').insertAfter('marquee-text');
// $(document).on('click', '.marquee-toggle', function () {
//     var $btn = $(this);
//     var $marquee = $btn.prev('marquee-text');
//     if ($btn.text() === 'Pause') {
//       $marquee.find('.scrolling-text__text').css('animation-play-state', 'paused');
//       $marquee.css('--marquee-animation-play-state', 'paused');
//       $btn.text('Play').attr('aria-pressed', 'true');
//     } else {
//       $marquee.find('.scrolling-text__text').css('animation-play-state', 'running');
//       $marquee.css('--marquee-animation-play-state', 'running');
//       $btn.text('Pause').attr('aria-pressed', 'false');
//     }
// });

const playIcon = `
<svg width="16" height="16" viewBox="0 0 24 24" fill="white" aria-hidden="true">
  <path d="M8 5v14l11-7z"></path>
</svg>`;
const pauseIcon = `
<svg width="16" height="16" viewBox="0 0 24 24" fill="white" aria-hidden="true">
  <path d="M6 5h4v14H6zm8 0h4v14h-4z"></path>
</svg>`;
$(`<button class="marquee-toggle" aria-pressed="false" style="background-color: #FD623D; color: white; padding: 5px; position: absolute; top: 15px;">${pauseIcon}</button>`)
  .insertAfter('marquee-text');
$(document).on('click', '.marquee-toggle', function () {
  var $btn = $(this);
  var $marquee = $btn.prev('marquee-text');
  if ($btn.attr('aria-pressed') === 'false') {
    $marquee.find('.scrolling-text__text').css('animation-play-state', 'paused');
    $marquee.css('--marquee-animation-play-state', 'paused');
    $btn.html(playIcon).attr('aria-pressed', 'true');
  } else {
    $marquee.find('.scrolling-text__text').css('animation-play-state', 'running');
    $marquee.css('--marquee-animation-play-state', 'running');

    $btn.html(pauseIcon).attr('aria-pressed', 'false');
  }
});

// $('form#contact-form-template--20230869287091__contact').each(function () {
//     $(this).prepend('<div class="required_message">Fields marked with * are required.</div>');
// });

var $wrapper = $(".pi-tab-label-wrapper");
var $container = $wrapper.find(".pi-top-tab-label-container");
var scrollAmount = 200;
  function initTabsNav() {
    if ($(window).width() <= 500) {
      if (!$wrapper.find(".tab-nav").length) {
        $wrapper.append('<button class="tab-nav prev">←</button>');
        $wrapper.append('<button class="tab-nav next">→</button>');
      }
    } else {
      $wrapper.find(".tab-nav").remove();
    }
  }
  initTabsNav();
  $(window).on("resize", function () {
    initTabsNav();
  });
  $wrapper.on("click", ".tab-nav.next", function () {
    $container.animate({
      scrollLeft: $container.scrollLeft() + scrollAmount
    }, 300);
  });
  $wrapper.on("click", ".tab-nav.prev", function () {
    $container.animate({
      scrollLeft: $container.scrollLeft() - scrollAmount
    }, 300);
});

$('#contact-form-template--20230869287091__contact').on('submit', function () {
    setTimeout(function () {
      const $successMessage = $('.a11y_customfocus');
      if ($successMessage.length) {
        $successMessage.focus();
      }
    }, 500);
});


// var $wrapper = $(".scroll-area");
// var scrollAmount = 300;
// function initBlogScrollNav() {
//   if ($(window).width() <= 500) {
//     if (!$wrapper.parent().find(".blog-nav").length) {
//       $wrapper.wrap('<div class="blog-scroll-wrapper" style="position:relative;"></div>');
//       $wrapper.after('<button class="blog-nav next">→</button>');
//       $wrapper.before('<button class="blog-nav prev">←</button>');
//     }
//   } else {
//     $(".blog-nav").remove();
//   }
// }
// initBlogScrollNav();
// $(window).on("resize", function () {
//   initBlogScrollNav();
// });
// $(document).on("click", ".blog-nav.next", function () {
//   $(".scroll-area").animate({
//     scrollLeft: $(".scroll-area").scrollLeft() + scrollAmount
//   }, 300);
// });
// $(document).on("click", ".blog-nav.prev", function () {
//   $(".scroll-area").animate({
//     scrollLeft: $(".scroll-area").scrollLeft() - scrollAmount
//   }, 300);
// });


console.log("a11y end");
});
